export const isDevEnvironment = window.location.host === "localhost:1508";

const BASE_URL = "/umbraco/api";

const ENDPOINT_IS_AUTHENTICATED = `${BASE_URL}/account/IsAuthenticated`;

export const ENDPOINT_GET_MEMBER_DATA = `${BASE_URL}/memberdata/GetMemberData`;
export const ENDPOINT_SAVE_MEMBER_DATA = `${BASE_URL}/memberdata/SaveMemberData`;

/* Profile */
export const ENDPOINT_GET_PERSON_MASTER_DATA = `${BASE_URL}/memberprofile/GetPersonMasterData`;
export const ENDPOINT_SET_PERSON_MASTER_DATA = `${BASE_URL}/memberprofile/SetPersonMasterData`;

export const ENDPOINT_GET_NEWSLETTER_SUBSCRIPTIONS = `${BASE_URL}/memberprofile/GetNewsletterSubscriptions`;
export const ENDPOINT_SET_NEWSLETTER_SUBSCRIPTION = `${BASE_URL}/memberprofile/SetNewsletterSubscriptions`;

export const ENDPOINT_GET_CAREER_BOOKINGS = `${BASE_URL}/memberprofile/GetCareerBookings`;
export const ENDPOINT_GET_BOOKING_URL = `${BASE_URL}/memberprofile/GetBookingUrl`;
export const ENDPOINT_DELETE_CAREER_BOOKING = `${BASE_URL}/memberprofile/DeleteBooking`;

export const ENDPOINT_GET_MY_EVENTS = `${BASE_URL}/memberprofile/GetMyEvents`;
export const ENDPOINT_GET_RECOMMENDED_CONTENT = `${BASE_URL}/memberprofile/GetRecommendedContentForMember`;
export const ENDPOINT_CANCEL_SIGNUP_FOR_EVENT = `${BASE_URL}/memberprofile/CancelSignupForEvent`;

export const ENDPOINT_GET_MY_MEMBERLIST = `${BASE_URL}/memberassignment/GetMyMemberList`;
export const ENDPOINT_GET_MY_MEMBERLIST_CSV = `${BASE_URL}/memberassignment/GetFilteredListAsCSV`;
export const ENDPOINT_GET_MY_MEMBERLIST_CSV_DOWNLOAD = `${BASE_URL}/memberassignment/DownloadCsv`;
export const ENDPOINT_GET_MY_MEMBERLIST_TREASURER_MENU = `${BASE_URL}/memberassignment/GetMyTreasurerMenu`;
export const ENDPOINT_GET_MY_MEMBERLIST_TREASURER_CSV = `${BASE_URL}/memberassignment/GetMyTreassurerInfo`;

export const ENDPOINT_GET_CONSENTS = `${BASE_URL}/memberprofile/GetConsents`;
export const ENDPOINT_SET_CONSENTS = `${BASE_URL}/memberprofile/SetConsents`;

/* Statistics */
export const ENDPOINT_GET_SALARY_DATA = `${BASE_URL}/statistics/GetSalaryData`;
export const ENDPOINT_SET_SALARY_DATA = `${BASE_URL}/statistics/SetSalaryData`;

export const ENDPOINT_GET_EDUCATIONS = `${BASE_URL}/statistics/GetEducations`;
export const ENDPOINT_GET_REGIONS = `${BASE_URL}/statistics/GetRegions`;
export const ENDPOINT_GET_JOB_SECTORS = `${BASE_URL}/statistics/GetJobSectors`;
export const ENDPOINT_GET_WORK_AREAS = `${BASE_URL}/statistics/GetWorkAreas`;
export const ENDPOINT_GET_JOB_ROLES = `${BASE_URL}/statistics/GetJobRoles`;
export const ENDPOINT_GET_JOB_POSITIONS = `${BASE_URL}/statistics/GetJobPositions`;

export const ENDPOINT_GET_SALARY_PREDICTION = `${BASE_URL}/statistics/GetPredictions`;
export const ENDPOINT_GET_JOB_FUNCTION_CALCULATIONS = `${BASE_URL}/statistics/GetJobFunctionCalculations`;
export const ENDPOINT_GET_BONUS_CALCULATIONS = `${BASE_URL}/statistics/GetBonusCalculations`;
export const ENDPOINT_GET_REGION_CALCULATIONS = `${BASE_URL}/statistics/GetRegionCalculations`;
export const ENDPOINT_GET_MY_ASSIGNMENTS = `${BASE_URL}/memberassignment/getmyassignments`;
export const ENDPOINT_GET_ASSIGNMENTS_TYPES = `${BASE_URL}/memberassignment/getassignmentstypes`;
export const ENDPOINT_CREATE_UPDATE_ASSIGNMENT = `${BASE_URL}/memberassignment/createupdate`;
export const ENDPOINT_CREATE_UPDATE_COMMENT = `${BASE_URL}/memberassignment/savetrcomment`;

/* Tools: Competence & Worklife user data */
export const DB_COLLECTION_ID_COMPETENCE_CHECK = "competence_check";
export const DB_COLLECTION_ID_JOB_SATISFACTION_CHECK = "job_satisfaction_check";

const headersDefault = Object.freeze({
  "Content-Type": "application/json",
});

export const getEndpoint = (ENDPOINT, POST = false, payload = null, doubleQuote = false) => {
  const options = {
    method: POST && !isDevEnvironment ? "POST" : "GET",
    headers: { ...{}, ...headersDefault },
    ...(POST &&
      !isDevEnvironment &&
      payload && {
        body: !doubleQuote ? JSON.stringify({ ...{}, ...payload }) : "\"" + JSON.stringify({ payload }).replaceAll("\"", "|") + "\"",
      }),
  };

  // if(isDevEnvironment) console.log({ENDPOINT, POST, payload})

  return fetch(ENDPOINT, options)
    .then((res) => res)
    .then(async (res) => {
      let returnData = null;
      try {
        returnData = await res.json();
      } catch (error) {
        returnData = { status: res.status };
      }

      if (res.status >= 400 && res.status < 600) {
        return {
          error: returnData.status,
          message: returnData.Message,
        };
      }

      return returnData;
    })
    .catch((error) => {
      console.log("getEndpoint ERROR", ENDPOINT, error);
      return {
        error: error,
        message: `getEndpoint ERROR: ${ENDPOINT}`,
      };
    });
};

/* Separate database containing saved JSON entries with data-stamps */
export const getCollectionData = (DB_COLLECTION_ID) => {
  const data = {
    collection: DB_COLLECTION_ID,
  };

  const options = {
    method: isDevEnvironment ? "GET" : "POST",
    headers: { ...{}, ...headersDefault },
    ...(!isDevEnvironment && { body: JSON.stringify({ ...{}, ...data }) }),
  };

  const devEndpoint = isDevEnvironment ? `/${DB_COLLECTION_ID}` : "";

  return fetch(ENDPOINT_GET_MEMBER_DATA + devEndpoint, options)
    .then((res) => res)
    .then((res) => res.json())
    .catch((error) => console.log(error));
};

export const saveCollectionData = (DB_COLLECTION_ID, payload) => {
  const data = {
    collection: DB_COLLECTION_ID,
    payload: payload,
  };

  const options = {
    method: "POST",
    headers: { ...{}, ...headersDefault },
    body: JSON.stringify({ ...{}, ...data }),
  };

  return fetch(ENDPOINT_SAVE_MEMBER_DATA, options)
    .then((res) => res)
    .then((res) => res.json())
    .catch((error) => console.log(error));
};

export const isAuthenticated = () => {
  const options = {
    method: "GET",
    headers: { ...{}, ...headersDefault },
  };

  return fetch(ENDPOINT_IS_AUTHENTICATED, options)
    .then((res) => res)
    .then((res) => res.json())
    .catch((error) => console.log(error));
};

/*
export const login = () => {
  const loginForm = document.getElementById("frontendChannelLogin")
  if(loginForm) {
    loginForm.submit()
  } else {
    console.log('frontendChannelLogin form missing on page')
  }
}
*/
